import type { StreamStatus } from '@/services/sse-ps-http/enums';
import type { PsHttpSSE } from '@/services/sse-ps-http/sse-ps-http';

/**
 * ParagraphFixRequestDTO
 */
export interface FixContentRequest {
    /**
     * 章节类型
     */
    chapter_type?: string;
    /**
     * 错误列表
     */
    errors?: string[];
    /**
     * 段落内容
     */
    original_content?: string;
    /**
     * 任务ID
     */
    task_id?: string;
}

/**
 * 核稿核查结果
 *
 * PatentExaminationResultRdResDTO
 */
export interface PatentExaminationResultRdResDTO {
    /**
     * 检查字段
     */
    check_field?: string;
    /**
     * 是否通过：true 通过；false 不通过
     */
    check_pass?: boolean;
    /**
     * 引用的检查规则项
     */
    check_rule_desc?: string;
    /**
     * 规则唯一编号
     */
    check_rule_id?: string;
    /**
     * 检查规则链接
     */
    check_url?: string;
    /**
     * 依赖字段
     */
    depend_field?: string[];
    /**
     * 修复类型
     */
    fix_type?: string;
    /**
     * 检查错误主键Id
     */
    id?: string;
    /**
     * 用户输入错误的文本段
     */
    origin_text?: string[];
    /**
     * 不通过原因
     */
    reason?: string;
}

export interface ApiContentResponse {
    content: string;
    status: StreamStatus;
}

export type FixContentResponse = PsHttpSSE<ApiContentResponse>;

export const FixContentApi = Symbol.for('FixContentApi');

export interface FixContentApi {
    fixContent(data: FixContentRequest): FixContentResponse;
}
